import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { CompaniesListComponent } from './companies-list/companies-list.component';
import { CompaniesRoutingModule } from './companies-routing.module';
import { CompanyComponent } from './company/company.component';
import { CompanyBanksComponent } from './company-banks/company-banks/company-banks.component';
import { CompanyBankComponent } from './company-banks/company-bank/company-bank.component';

@NgModule({
  imports: [
    CommonModule,
    CompaniesRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    CompaniesListComponent,
    CompanyComponent,
    CompanyBanksComponent,
    CompanyBankComponent
  ],
  entryComponents: [
    CompanyComponent,
    CompanyBankComponent
  ]
})
export class CompaniesModule {
}
